import { RadioGroup, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CancelModalBodyContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

export const CancelModalStyledBody = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.tokens.bottomSheetValueBody,
  textAlign: 'center',
}));

export const CancelModalRadioGroup = styled(RadioGroup)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '&> .separator': {
    width: '100%',
    height: '0.1rem',
    background: theme.tokens.summaryBorder,
  },
}));
